import { useState } from 'react';
import { createCategory } from '../services/categoryService'; // Assurez-vous que le chemin est correct

/**
 * Hook personnalisé pour gérer la logique du formulaire de création de catégorie rapide.
 * * @param {object} currentUser - L'objet utilisateur pour obtenir l'ID.
 * @param {function} onCategoryCreated - Callback pour mettre à jour l'ID de catégorie dans le formulaire parent.
 * @param {function} refreshAllData - Callback pour rafraîchir la liste globale des catégories.
 * @returns {object} { showCategoryForm, newCategoryName, newCategoryType, setNewCategoryName, setNewCategoryType, setShowCategoryForm, handleCreateCategory }
 */
export const useCategoryForm = (currentUser, onCategoryCreated, refreshAllData) => {
    
    const [showCategoryForm, setShowCategoryForm] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState("");
    const [newCategoryType, setNewCategoryType] = useState('D'); // Dépense par défaut

    const handleCreateCategory = async (e) => {
        e.preventDefault();
        if (!newCategoryName || !currentUser?.id) return;

        try {
            const newCategory = await createCategory({
                name: newCategoryName,
                type: newCategoryType,
                userId: currentUser.id,
            });

            // 1. Appeler la fonction de callback du composant parent
            onCategoryCreated(newCategory.id, newCategory);

            // 2. Réinitialiser et fermer le formulaire du hook
            setNewCategoryName("");
            setNewCategoryType('D');
            setShowCategoryForm(false);

            // 3. Rafraîchir les données globales (si la fonction est fournie)
            if (refreshAllData) {
                refreshAllData();
            }

        } catch (error) {
            console.error(`Erreur lors de la création de la catégorie : ${error.message}`);
            alert(`Erreur lors de la création de la catégorie : ${error.message}`);
        }
    };
    
    return {
        showCategoryForm,
        newCategoryName,
        newCategoryType,
        setNewCategoryName,
        setNewCategoryType,
        setShowCategoryForm,
        handleCreateCategory,
    };
};